"use strict";

require('./js/dgs-megamenu');